import { useState, useEffect } from "react";
import { Button } from "Components/Button";
import { getMedicalClaimFile } from "Requests/Partners/PreBudgets";
import { Box } from "styles/globalComponents";
import { RotateCcw, RotateCw } from "lucide-react";
import { DocumentItem } from "./DocumentItem";

interface DocumentsProps {
  files: { file_path: string }[] | undefined;
}

export const Documents = ({ files }: DocumentsProps) => {
  const [tabSelected, setTabSelected] = useState(1);
  const [fileBlob, setFileBlob] = useState<Blob | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [rotations, setRotations] = useState<{ [key: string]: number }>({});

  const currentFileView = files?.[tabSelected - 1];

  const currentRotation = currentFileView
    ? rotations[currentFileView.file_path] || 0
    : 0;

  const handleRotateLeft = () => {
    if (currentFileView) {
      setRotations((prev) => ({
        ...prev,
        [currentFileView.file_path]:
          (prev[currentFileView.file_path] || 0) - 90,
      }));
    }
  };

  const handleRotateRight = () => {
    if (currentFileView) {
      setRotations((prev) => ({
        ...prev,
        [currentFileView.file_path]:
          (prev[currentFileView.file_path] || 0) + 90,
      }));
    }
  };

  const openImageNewTab = () => {
    if (currentFileView?.file_path) {
      window.open(currentFileView.file_path, "_blank");
    }
  };

  useEffect(() => {
    const fetchFile = async () => {
      if (currentFileView?.file_path) {
        setIsLoading(true);
        try {
          const blob = await getMedicalClaimFile(currentFileView.file_path);
          setFileBlob(blob);
        } catch (error) {
          console.error("Erro ao buscar arquivo:", error);
          setFileBlob(null);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchFile();
  }, [currentFileView?.file_path]);

  // Cleanup object URL quando o componente for desmontado ou o blob mudar
  useEffect(() => {
    return () => {
      if (fileBlob) {
        // O object URL será limpo automaticamente quando o blob for destruído
      }
    };
  }, [fileBlob]);

  return (
    <div className="documents-preview-style">
      <div className="tabs">
        <Box display="flex" gap="5" wrap="wrap">
          {files?.map((file, index) => (
            <Button
              key={file.file_path}
              onClick={() => setTabSelected(index + 1)}
              outlined
              {...(index + 1 === tabSelected && { outlined: false })}
            >
              Arquivo {index + 1}
            </Button>
          ))}
        </Box>

        <Box display="flex" justify="end" gap="3">
          <Button onClick={handleRotateLeft} outlined>
            <RotateCcw size={16} />
            <span>Girar Esquerda</span>
          </Button>
          <Button onClick={handleRotateRight} outlined>
            <RotateCw size={16} />
            <span>Girar Direita</span>
          </Button>
        </Box>

        <Box display="flex" justify="center" className="external-link">
          <Button onClick={openImageNewTab}>Abrir imagem em nova aba</Button>
        </Box>
      </div>

      <div className="documents-preview">
        {currentFileView && (
          <DocumentItem
            index={tabSelected}
            fileBlob={fileBlob}
            isLoading={isLoading}
            rotation={currentRotation}
          />
        )}
      </div>
    </div>
  );
};
